import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { assets } from '../../constants/assets.const';

@Component({
  selector: 'mindbase-no-data-found',
  standalone: true,
  imports: [TranslateModule],
  template: `<div class="ndf">
    <figure class="not-found ">
      <img class="not-found-image" [src]="assetsConst.noDataFound" />
    </figure>
    <h3 class="n_dta">{{ 'NoDataFound' | translate }}</h3>
  </div> `,
  styles: [
    `
    .ndf {
      text-align: center;
    }
  `
  ]
})
export class NoDataFoundComponent {
  protected assetsConst = assets;
}
